<h2>{{ title }}</h2>
@let isBusiness = form.controls.isBusiness.value;
<form [formGroup]="form.controls.payment">
  <button
    class="business-toggle unstyled-button"
    type="button"
    (click)="toggleBusiness()"
    [attr.aria-label]="isBusiness ? 'Erhverv' : 'Privat'"
  >
    <span class="privat" [class.selected]="!isBusiness">Privat</span>
    <span class="business" [class.selected]="isBusiness">Erhverv</span>
  </button>

  <div class="inputs">
    @if (isBusiness) {
      <app-text-input
        [control]="form.controls.payment.controls.companyName"
        [name]="billingAddressContent.companyLabel"
        [placeholder]="billingAddressContent.companyPlaceholder"
      ></app-text-input>
      <app-text-input
        [control]="form.controls.payment.controls.CVR"
        type="number"
        [name]="billingAddressContent.CVRLabel"
        [placeholder]="billingAddressContent.CVRPlaceholder"
      ></app-text-input>
      @if (enableEAN) {
        <app-text-input
          [control]="form.controls.payment.controls.EAN"
          [name]="billingAddressContent.eanLabel"
          [placeholder]="billingAddressContent.eanPlaceholder"
        ></app-text-input>
        <app-text-input
          [control]="form.controls.payment.controls.requisition"
          [name]="billingAddressContent.requisitionLabel"
          [placeholder]="billingAddressContent.requisitionPlaceholder"
        ></app-text-input>
      }
      <app-text-input
        [control]="form.controls.payment.controls.invoiceRecipientName"
        [name]="billingAddressContent.invoiceRecipientNameLabel"
        [placeholder]="billingAddressContent.invoiceRecipientNamePlaceholder"
      ></app-text-input>
      <app-text-input
        [control]="form.controls.payment.controls.invoiceRecipientEmail"
        [name]="billingAddressContent.invoiceRecipientEmailLabel"
        [placeholder]="billingAddressContent.invoiceRecipientEmailPlaceholder"
      ></app-text-input>
    }

    <app-text-input
      [control]="form.controls.payment.controls.firstName"
      [name]="billingAddressContent.firstNameLabel"
      [placeholder]="billingAddressContent.firstNamePlaceholder"
    ></app-text-input>
    <app-text-input
      [control]="form.controls.payment.controls.lastName"
      [name]="billingAddressContent.lastNameLabel"
      [placeholder]="billingAddressContent.lastNamePlaceholder"
    ></app-text-input>
    <app-text-input
      [control]="form.controls.payment.controls.email"
      type="email"
      [name]="billingAddressContent.emailLabel"
      [placeholder]="billingAddressContent.emailPlaceholder"
    ></app-text-input>
    <app-text-input
      [control]="form.controls.payment.controls.telephone"
      type="tel"
      [name]="billingAddressContent.phoneLabel"
      [placeholder]="billingAddressContent.phonePlaceholder"
    ></app-text-input>
    <app-text-input
      class="large-field"
      [control]="form.controls.payment.controls.address"
      [name]="billingAddressContent.addressLabel"
      [placeholder]="billingAddressContent.addressPlaceholder"
    ></app-text-input>
    <app-text-input
      [control]="form.controls.payment.controls.zip"
      [name]="billingAddressContent.zipCodeLabel"
      [placeholder]="billingAddressContent.zipCodePlaceholder"
    ></app-text-input>
    <app-text-input
      [control]="form.controls.payment.controls.city"
      [name]="billingAddressContent.cityLabel"
      [placeholder]="billingAddressContent.cityPlaceholder"
    ></app-text-input>
  </div>
</form>
